import http from "./http.service";
import { getDispatch } from "utils/dispatch.util";
import { loadersActions } from "store/slices/loader.slice";
import { reserDataActions } from "store/slices/reserData.slice";

const ReservationData = {
  async getReservationData({ currentPage, searchBy = "" }) {
    const dispatch = getDispatch();
    dispatch(loadersActions.setLoadingResData(true));
    const [res, error] = await http.get(`admin/reservation?search=${searchBy}&page=${currentPage}`);
    dispatch(loadersActions.setLoadingResData(false));
    if (res?.data?.success === true) {
      dispatch(reserDataActions.setReservationData(res?.data));
    }
    return [res, error];
  },
};

export default ReservationData;
